<template>
  <div class="class-header-content">
    <!--<div class="title-2" style="padding: 5px">班主任详细处理情况</div>-->
    <TableList
      :tableData="tableData"
      :columns="columns"
      bordered
      :loading="loading"
      :scroll="() => {}"
      :rowClassName="rowClassName"
    >
      <template v-slot:studentCount="{ record }">
        <div @click="goDetail(record, 0)" class="cell">
          <span class="total">{{ record.timeStats.studentCount || 0 }}</span>
          <span v-if="record.timeStats.pendingCount > 0" class="pending">
            未处理 {{ record.timeStats.pendingCount }}
          </span>
        </div>
      </template>
      <template v-slot:continuousStatsCount="{ record }">
        <div @click="goDetail(record, 1)" class="cell">
          <span class="total">{{ record.timeStats.continuousStatsCount || 0 }}</span>
          <span v-if="record.timeStats.continuousStatsPendingCount > 0" class="pending">
            未处理 {{ record.timeStats.continuousStatsPendingCount }}
          </span>
        </div>
      </template>
    </TableList>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'

export default {
  name: 'ClassTeaHandSituat',
  components: { TableList },
  data() {
    return {
      loading: false,
      tableData: [],
      dateRangeObj: {},
      columns: [
        {
          title: '提醒分类',
          dataIndex: 'typeName',
          align: 'left',
        },
        {
          title: '提醒人数',
          dataIndex: 'studentCount',
          align: 'left',
          scopedSlots: { customRender: 'studentCount' },
        },
        {
          title: '连续提醒人数(≥2次)',
          dataIndex: 'continuousStatsCount',
          align: 'left',
          scopedSlots: { customRender: 'continuousStatsCount' },
        },
        // {
        //   title: '本周（人次）',
        //   dataIndex: 'week',
        //   align: 'left',
        //   scopedSlots: { customRender: 'week' },
        // },
        // {
        //   title: '本月（人次）',
        //   dataIndex: 'month',
        //   align: 'left',
        //   scopedSlots: { customRender: 'month' },
        // },
        // {
        //   title: '全部（人次）',
        //   dataIndex: 'all',
        //   align: 'left',
        //   scopedSlots: { customRender: 'all' },
        // },
      ],
    }
  },

  methods: {
    async getReminderDataList(dateRangeObj = {}) {
      this.loading = true
      this.dateRangeObj = dateRangeObj
      const res = await getAction('/statisticV2/getReminderDataList', dateRangeObj)
      const { success, result } = res
      if (success) {
        this.tableData = result
      }
      this.loading = false
    },
    rowClassName(record) {
      return record.type === 4 ? 'high-light-row' : ''
    },
    goDetail(record, continuousFlag) {
      const query = {
        index: record.type,
        ...this.dateRangeObj,
        // 未处理数量
        pendingCount: continuousFlag
          ? record.timeStats?.continuousStatsPendingCount
          : record.timeStats?.pendingCount,
        // 是否为连续提醒：0-否 1-是
        continuousFlag,
      }
      this.$router.push({
        path: '/CommonPage/XddRemindStudent',
        query,
      })
    },
  },
}
</script>
<style scoped lang="less">
.class-header-content {
  /deep/ .title-area {
    margin-bottom: 0 !important;
  }
  /deep/ .high-light-row {
    overflow: hidden !important;
    border-radius: 5px !important;
    background-color: #fff1e8 !important;
  }
  box-sizing: border-box;
  height: 360px;
  padding: 20px 30px;
  border-radius: 8px;
  background-color: #fff;
  .cell {
    cursor: pointer;
    .total {
      flex: 1;
      font-size: 16px;
      color: #2d2d2d;
      font-weight: 600;
    }
    .pending {
      flex: 1;
      margin-left: 10px;
      color: #fa5a25;
    }
  }
}
</style>
